import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { CalculatorAxios } from "../../axios/calculator/calculator.axios";
import { CalculateForThresholdsDto } from "../../model/calculator/dto/CalculateForThresholdDto";
import { CalculateForThresholdsResponseDto } from "../../model/calculator/dto/CalculateForThresholdresponseDto";
import { GetPricesResponseDto } from "../../model/calculator/dto/GetPricesResponseDto";
import { ThresholdKinds } from "../../model/threshold/types/ThresholdKinds.enum";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

interface CalculatorReducer {
  calculateResponse: CalculateForThresholdsResponseDto;
  prices: GetPricesResponseDto;
}

const initialState = Object.freeze<CalculatorReducer>({
  calculateResponse: {
    fields: {
      [ThresholdKinds.CUSTOM_FIELDS]: 0,
      [ThresholdKinds.ENTRIES]: 0,
      [ThresholdKinds.FORMS]: 0,
      [ThresholdKinds.KANBANS]: 0,
      [ThresholdKinds.USERS]: 0,
      [ThresholdKinds.MOBILE_APP]: 0,
      [ThresholdKinds.MODULES_DEFINITIONS]: 0,
    },
    total: 0,
  },
  prices: {
    [ThresholdKinds.CUSTOM_FIELDS]: 0,
    [ThresholdKinds.ENTRIES]: 0,
    [ThresholdKinds.FORMS]: 0,
    [ThresholdKinds.KANBANS]: 0,
    [ThresholdKinds.USERS]: 0,
    [ThresholdKinds.MOBILE_APP]: 0,
    [ThresholdKinds.MODULES_DEFINITIONS]: 0,
  },
});

const calculateForThresholds = AtiraThunk<
  CalculateForThresholdsResponseDto,
  CalculateForThresholdsDto
>("/calculate", (dto) => CalculatorAxios.calculateForThresholds(dto));

const getPrices = AtiraThunk<GetPricesResponseDto, void>(
  "/calculate/prices",
  () => CalculatorAxios.getPrices(),
);

const calculatorSlice = createSlice({
  name: "claculator",
  initialState,
  reducers: {
    resetState: (state) => {
      state.calculateResponse = initialState.calculateResponse;
    },
  },
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(calculateForThresholds.fulfilled, (state, action) => {
      state.calculateResponse = action.payload;
    });

    addCase(getPrices.fulfilled, (state, action) => {
      state.prices = action.payload;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const calculatorActions = {
  ...calculatorSlice.actions,
  calculateForThresholds,
  getPrices,
};

export default calculatorSlice.reducer;
